export default __webpack_public_path__ + "static/media/CLICHY (36 sur 176).8db4198d.jpg";